


(function($){
    let scrolling = false;
    let form_anchor= $('#form_anchor');
    let loadingForm = false , FormLoaded = false;

    window.isInViewport = function(elem) {
        let elementTop = elem.offset().top;
        let elementBottom = elementTop + elem.outerHeight();

        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        //return elementBottom > viewportTop && elementTop < viewportBottom;
        return elementTop < viewportBottom;
    };

    function doScrolling() {

        if (!loadingForm && form_anchor.length > 0  && window.isInViewport(form_anchor)) {
            loadingForm = true;
            !FormLoaded && import(/* webpackChunkName: "registration" */'../registration/registration.js')
                .then(module => {
                    loadingForm = false;
                    FormLoaded = true;
                   });
        }
    }

    window.scrollingTasks.push(doScrolling);

})(window.jQuery);
